module.exports = __webpack_public_path__ + "6b3c06e372dda296aa286e1616a8a3fd.svg";